import React, { useState } from 'react';
import { Container, Badge, Row, Col, Card, Table, Modal, Button, Pagination } from 'react-bootstrap';
import TitleBar from '../../../subscreens/admin/TitleBar';
import { Line, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import '../../../assets/css/admin/dashboardCSS/Dashboard.css';
import {
  Users,
  Heart,
  FileText,
  DollarSign,
  Eye,
  User,
  Mail,
  Phone,
  MapPin,
  BookOpen,
  Calendar
} from 'lucide-react';

import Adminlayout from '../../../layouts/admin/Adminlayout';





// Register ChartJS components
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Stats Data
  const [stats] = useState({
    totalStudents: 245,
    totalDonors: 128,
    totalNGO: 10,
    totalDonations: 1250000
  });

//   // Monthly Donations Chart Data
   const monthlyDonationsData = {
     labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
     datasets: [
       {
         label: 'Donations (PKR)',
         data: [65000, 85000, 95000, 120000, 110000, 140000, 130000, 150000, 145000, 160000, 155000, 175000],
         borderColor: '#10183f',
         backgroundColor: 'rgba(16, 24, 63, 0.1)',
         tension: 0.4,
         fill: true
                }
    ]
   };

   // Request Status Pie Chart Data
  const requestStatusData = {
    labels: ['Pending', 'Approved', 'Rejected', 'Completed'],
    datasets: [
      {
        data: [25, 35, 10, 19],
        backgroundColor: ['#ffc107', '#28a745', '#dc3545', '#10183f'],
        borderColor: '#ffffff',
        borderWidth: 2
      }
    ]
  };

  // Recent Requests Data with Full Details
  const [recentRequests] = useState([
    { 
      id: 1, 
      student: 'Ali Ahmed', 
      studentId: 'STD-101',
      email: 'ali@gmail.com',
      phone: '0300-1234567',
      address: 'House 123, Street 45, Lahore',
      type: 'Fee', 
      amount: '20,000', 
      status: 'Pending',
      requestDate: '2025-08-15',
      description: 'Need financial assistance for semester fee payment.',
      institution: 'Punjab University'
    },
    { 
      id: 2, 
      student: 'Sara Khan', 
      studentId: 'STD-102',
      email: 'sara@gmail.com',
      phone: '0301-9876543',
      address: 'House 456, Street 78, Karachi',
      type: 'Books', 
      amount: '---', 
      status: 'Approved',
      requestDate: '2025-08-12',
      description: 'Required textbooks for the new semester.',
      institution: 'Karachi University'
    },
    { 
      id: 3, 
      student: 'Ahmed Raza', 
      studentId: 'STD-103',
      email: 'ahmed@gmail.com',
      phone: '0302-5551234',
      address: 'House 789, Street 12, Islamabad',
      type: 'Uniform', 
      amount: '5,000', 
      status: 'Pending',
      requestDate: '2025-08-18',
      description: 'School uniform for the academic year.',
      institution: 'Islamabad Model School'
    },
    { 
      id: 4, 
      student: 'Fatima Ali', 
      studentId: 'STD-104',
      email: 'fatima@gmail.com',
      phone: '0303-7778888',
      address: 'House 321, Street 99, Lahore',
      type: 'Fee', 
      amount: '25,000', 
      status: 'Completed',
      requestDate: '2025-08-05',
      description: 'Semester fee assistance for engineering program.',
      institution: 'UET Lahore'
    },
    { 
      id: 5, 
      student: 'Hassan Malik', 
      studentId: 'STD-105',
      email: 'hassan@gmail.com',
      phone: '0304-4445555',
      address: 'House 654, Street 33, Faisalabad',
      type: 'Books', 
      amount: '---', 
      status: 'Approved',
      requestDate: '2025-08-20',
      description: 'Medical textbooks for MBBS second year.',
      institution: 'Faisalabad Medical College'
    }
  ]);

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRequests = recentRequests.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(recentRequests.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getStatusClass = (status) => {
    return status.toLowerCase();
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'Pending': 'warning',
      'Approved': 'success',
      'Rejected': 'danger',
      'Completed': 'primary'
    };
    return statusMap[status] || 'secondary';
  };

  const handleViewRequest = (request) => {
    setSelectedRequest(request);
    setShowDetailModal(true);
  };

  return (
    <Adminlayout>
    <div className="adb-admin-dashboard">
      <Container fluid>
        {/* Page Header */}
           <TitleBar
                title="Admin Dashboard"
                subtitle="Overview of system statistics and controls"
              ></TitleBar>
           {/* Stats Cards */}
        <Row className="adb-stats-row">
          <Col lg={3} md={6} className="mb-4">
            <Card className="adb-admin-stat-card">
              <Card.Body>
                <div className="adb-stat-icon-wrapper students-icon">
                  <Users size={30} />
                </div>
                <h3 className="adb-stat-number">{stats.totalStudents}</h3>
                <p className="adb-stat-label">Total Students</p>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <Card className="adb-admin-stat-card">
              <Card.Body>
                <div className="adb-stat-icon-wrapper donors-icon">
                  <Heart size={30} />
                </div>
                <h3 className="adb-stat-number">{stats.totalDonors}</h3>
                <p className="adb-stat-label">Total Donors</p>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <Card className="adb-admin-stat-card">
              <Card.Body>
                <div className="adb-stat-icon-wrapper requests-icon">
                  <FileText size={30} />
                </div>
                <h3 className="adb-stat-number">{stats.totalNGO}</h3>
                <p className="adb-stat-label">Total NGOs</p>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <Card className="adb-admin-stat-card">
              <Card.Body>
                <div className="adb-stat-icon-wrapper donations-icon">
                  <DollarSign size={30} />
                </div>
                <h3 className="adb-stat-number">PKR {stats.totalDonations.toLocaleString()}</h3>
                <p className="adb-stat-label">Total Donations</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Charts Row */}
        <Row className="adb-charts-row">
          <Col lg={8} className="mb-4">
            <Card className="adb-chart-card">
              <Card.Body>
                <h4 className="adb-chart-title">Monthly Donations</h4>
                <Line 
                  data={monthlyDonationsData} 
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                      legend: {
                        display: true,
                        position: 'top'
                      }
                    },
                    scales: {
                      y: {
                        beginAtZero: true
                      }
                    }
                  }} 
                />
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4} className="mb-4">
            <Card className="adb-chart-card">
              <Card.Body>
                <h4 className="adb-chart-title">Requests Status</h4>
                <Pie 
                  data={requestStatusData}
                  options={{
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                      legend: {
                        position: 'bottom'
                      }
                    }
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Recent Requests Table */}
        <Row>
          <Col lg={12}>
            <Card className="adb-requests-card">
              <Card.Body>
                <h4 className="adb-table-title">Recent Requests</h4>
                <Table responsive hover className="adb-requests-table">
                  <thead>
                    <tr>
                      <th>Student</th>
                      <th>Type</th>
                      <th>Amount (PKR)</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRequests.map((request) => (
                      <tr key={request.id}>
                        <td className="adb-student-name">{request.student}</td>
                        <td>{request.type}</td>
                        <td>{request.amount}</td>
                        <td>
                          <span className={`adb-status-badge ${getStatusClass(request.status)}`}>
                            {request.status}
                          </span>
                        </td>
                        <td>
                          <button 
                            className="adb-view-btn"
                            onClick={() => handleViewRequest(request)}
                          >
                         <Eye size={16} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* Pagination */}
                <div className="adb-pagination-wrapper">
                  <Pagination className="adb-pagination">
                    <Pagination.First 
                      onClick={() => paginate(1)} 
                      disabled={currentPage === 1}
                    />
                    <Pagination.Prev 
                      onClick={() => paginate(currentPage - 1)} 
                      disabled={currentPage === 1}
                    />
                    
                    {[...Array(totalPages)].map((_, index) => (
                      <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage}
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}

                    <Pagination.Next 
                      onClick={() => paginate(currentPage + 1)} 
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last 
                      onClick={() => paginate(totalPages)} 
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Request Detail Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered>
        <Modal.Header closeButton className="adb-modal-header">
          <Modal.Title>Request Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRequest && (
            <div className="adb-request-details-modal">
              <Row>
                {/* Student Information Section */}
                <Col md={12} className="mb-3">
                  <div className="adb-detail-section-header">
                    <h5>Student Information</h5>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <User size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Student ID</p>
                      <p className="adb-detail-value">{selectedRequest.studentId}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <User size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Student Name</p>
                      <p className="adb-detail-value">{selectedRequest.student}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <Mail size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Email</p>
                      <p className="adb-detail-value">{selectedRequest.email}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <Phone size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Phone</p>
                      <p className="adb-detail-value">{selectedRequest.phone}</p>
                    </div>
                  </div>
                </Col>

                <Col md={12} className="mb-3">
                  <div className="adb-info-item-modal">
                    <MapPin size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Address</p>
                      <p className="adb-detail-value">{selectedRequest.address}</p>
                    </div>
                  </div>
                </Col>

                <Col md={12} className="mb-3">
                  <div className="adb-info-item-modal">
                    <BookOpen size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Institution</p>
                      <p className="adb-detail-value">{selectedRequest.institution}</p>
                    </div>
                  </div>
                </Col>

                {/* Request Information Section */}
                <Col md={12} className="mb-3 mt-3">
                  <div className="adb-detail-section-header">
                    <h5>Request Information</h5>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <FileText size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Request Type</p>
                      <p className="adb-detail-value">{selectedRequest.type}</p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <DollarSign size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Amount</p>
                      <p className="adb-detail-value adb-amount-highlight">
                        {selectedRequest.amount !== '---' ? `PKR ${selectedRequest.amount}` : 'N/A'}
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <Calendar size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Request Date</p>
                      <p className="adb-detail-value">
                        {new Date(selectedRequest.requestDate).toLocaleDateString('en-GB')}
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6} className="mb-3">
                  <div className="adb-info-item-modal">
                    <FileText size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Status</p>
                      <div>
                        <Badge bg={getStatusBadge(selectedRequest.status)} className="adb-status-badge-large">
                          {selectedRequest.status}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={12} className="mb-3">
                  <div className="adb-info-item-modal">
                    <FileText size={18} className="adb-info-icon-modal" />
                    <div>
                      <p className="adb-detail-label">Description</p>
                      <p className="adb-detail-value">{selectedRequest.description}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </Adminlayout>
  );
};

export default Dashboard;